import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';



@Injectable({
    providedIn: 'root',
})
export class AuthGuard  {
    constructor(private authService: AuthService, private router: Router) {}



    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):  Observable<boolean> {
        return this.authService.user$.pipe(
            map(user => {
                const requireSignIn: boolean = route.data.requireSignIn;
                if(typeof user !== 'undefined' && user !== null) {
                    console.log(' >>>> current url:' + this.router.url);
                    if (requireSignIn === false) {
                        // 已登入但又連到登入頁面，導向access_records
                        // this.router.navigateByUrl('/access_records');
                        return true;
                    }
                    else {
                        return true;
                    }
                } else {
                    // 瀏覽的頁面不需登入
                    if (requireSignIn === false) {
                        return true;
                    }
                    // 未登入，導向登入頁面

                    this.router.navigateByUrl('/');
                    return false;
                }


            })
        );


        throw new Error("Method not implemented.");
    }



}
